var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24.766,
    height: 24.81,
    viewBox: "0 0 24.766 24.81",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10578",
    "data-name": "Rectangle 10578",
    width: 24.766,
    height: 24.81,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_11830",
    "data-name": "Group 11830",
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11828",
    "data-name": "Group 11828",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4753",
    "data-name": "Path 4753",
    d: "M21.956,24.81H2.805a1.084,1.084,0,0,0-.133-.045,3.166,3.166,0,0,1-2.556-2.3C.068,22.311.038,22.154,0,22V4.749a.957.957,0,0,0,.044-.135A3.134,3.134,0,0,1,2.732,1.986a17.163,17.163,0,0,1,1.854-.047c.271,0,.541,0,.83,0,0-.333.017-.638,0-.942A.905.905,0,0,1,6,0h.387a.911.911,0,0,1,.585,1c-.023.309,0,.621,0,.925H17.8c0-.317.018-.623,0-.927a.906.906,0,0,1,.584-1h.387a.911.911,0,0,1,.585,1c-.023.309,0,.621,0,.938.773,0,1.506,0,2.239,0a3.182,3.182,0,0,1,3.175,3.174c.007,5.506.015,11.013-.006,16.519a3.058,3.058,0,0,1-1.97,2.93,6.353,6.353,0,0,1-.826.247M1.548,8.539v.282q0,6.323,0,12.646a1.658,1.658,0,0,0,1.8,1.791H21.406a1.66,1.66,0,0,0,1.808-1.8q0-6.323,0-12.646v-.27ZM6.964,3.5c0,.252,0,.478,0,.7a.776.776,0,1,1-1.547-.009c0-.23,0-.461,0-.7-.759,0-1.483,0-2.208,0A1.592,1.592,0,0,0,1.576,4.907c-.065.677-.013,1.365-.013,2.057H23.214c0-.608,0-1.2,0-1.8A1.642,1.642,0,0,0,21.546,3.49c-.669-.005-1.338,0-2.006,0-.061,0-.122.011-.195.018,0,.241,0,.466,0,.691a.776.776,0,1,1-1.547,0c0-.231,0-.461,0-.7Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.d43a650e9798a64a6384f57fd8ad38c6.svg";
export { ForwardRef as ReactComponent };